import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import { Router } from '@angular/router';
import { MessagesService } from '../shared/services/messages/messages.service';
import { ReadConfigService } from '../shared/services/common/read-config.service';
import { DisplayNotificationService } from '../shared/services/common/notification.service';
import { GridDataResult, SelectableSettings, PageChangeEvent } from '@progress/kendo-angular-grid';
import { CompositeFilterDescriptor, SortDescriptor, orderBy, filterBy } from '@progress/kendo-data-query';
import { HttpErrorResponse } from '@angular/common/http';
import { UsersService } from '../shared/services/common/users.service';
import { AuthService } from '../shared/services/auth/auth.service';

@Component({
  selector: 'app-messages',
  templateUrl: './messages.component.html',
  styleUrls: ['./messages.component.css']
})
export class MessagesComponent implements OnInit {

  messagesData: any;
  selectedData = new Array();
  gridData: GridDataResult;
  filters: CompositeFilterDescriptor;
  sort: SortDescriptor[] = [{
    field: 'receivedDt',
    dir: 'desc'
  }];
  pageSize = 10;
  skip = 0;
  gridView: any[];
  gridLoading: boolean;
  messageCount = 0;
  composeMessage: boolean;
  winHandle: Window;
  openMessage = false;
  selectedValue = 'Received Messages';
  listItems: Array<string> = ['Received Messages', 'Sent Messages', 'Archived Messages'];
  allMessages = [];
  selectedSubject: any;
  selectedTopic: any;
  opened = false;
  selectableSettings: SelectableSettings;
  sentMessage = false;
  msgData: any;
  deleteDisabled = true;
  hiddenColumns: string[] = [];
  @Output() updateMsgCount: EventEmitter<any> = new EventEmitter<any>();
  scrollMessage: any;
  showAppOutage: boolean;
  appOutageMessage: any;
  inputData: { userInfo: any; };

  constructor(
    private router: Router,
    private authService: AuthService,
    private usersService: UsersService,
    private messagesService: MessagesService,
    private readConfigService: ReadConfigService,
    private notificationService: DisplayNotificationService) { }

  ngOnInit() {
    if (this.authService.isLoggedIn) {
      this.authService.loggedInChecker(this.authService.isLoggedIn);
    }
    this.scrollMessage = this.readConfigService.getMobileScrollMessage();
    this.inputData = { userInfo: this.usersService.UserInfo() };
    this.loadData();
    this.selectableSettings = { checkboxOnly: true, mode: 'multiple' };
  }

  compose() {
    this.composeMessage = true;
  }

  close() {
    this.composeMessage = false;
    this.openMessage = false;
    this.opened = false;
  }

  closeDialog() {
    this.composeMessage = false;
    this.openMessage = false;
    this.opened = false;
    this.loadData();
  }

  updateGrid() {
    const updatedCount = this.messageCount - 1;
    this.messagesService.setMsgCount(updatedCount.toString());
    this.messageCount = updatedCount;
    this.loadData();
  }

  loadData() {
    this.notificationService.setUpLoading(true);
    this.messagesService.getSecureMessages(this.inputData).subscribe((data: any) => {
      if (data && data.statusCode === 200) {
        this.popuplateGridData(data.result);
      } else if (data && data.statusCode === 204) {
        this.popuplateGridData([]);
      } else if (data && data.statusCode === 403) {
        this.router.navigate(['/forbidden']);
      } else {
        this.notificationService.setErrorNotification();
      }
      this.notificationService.setUpLoading(false);
    },
      (err: HttpErrorResponse) => {
        console.log(err.error);
        this.notificationService.setErrorNotification();
        this.notificationService.setUpLoading(false);
      });
  }

  delete() {
    this.opened = true;
  }

  deleteMessage() {
    this.opened = false;
    const data: any = { ...this.inputData };
    data.msgIds = this.selectedData.toString();
    this.messagesService.deleteMessage(data).subscribe((response: any) => {
      if (response && response.statusCode === 200) {
        this.popuplateGridData(response.result);
      } else if (data && data.statusCode === 204) {
        this.popuplateGridData([]);
      } else if (response && response.statusCode === 403) {
        this.router.navigate(['/forbidden']);
      } else {
        this.notificationService.setErrorNotification();
      }
    },
      (err: HttpErrorResponse) => {
        console.log(err.error);
        this.notificationService.setErrorNotification();
      });
  }

  popuplateGridData(data: any) {
    this.deleteDisabled = true;
    this.allMessages = data;
    this.filterGridView(this.selectedValue);
  }

  filterGridView(value: any) {
    this.selectedData = [];
    this.deleteDisabled = true;
    if (this.allMessages.length < 0) {
      return;
    }
    if (value === 'Sent Messages') {
      this.messagesData = this.allMessages.filter((x: any) => x.sendDt !== null && !x.deleted);
      this.sort = [{
        field: 'sendDt',
        dir: 'desc'
      }];
    } else if (value === 'Received Messages') {
      this.messagesData = this.allMessages.filter((x: any) => x.receivedDt !== null && !x.deleted);
      this.messageCount = this.messagesData.filter((x: any) => !x.read).length;
      this.messagesService.collection$.subscribe(response => {
        this.messageCount = response;
      });
      this.messagesService.setMsgCount(this.messageCount.toString());
      this.sort = [{
        field: 'receivedDt',
        dir: 'desc'
      }];
    } else {
      this.messagesData = this.allMessages.filter((x: any) => x.receivedDt !== null && x.deleted);
      this.sort = [{
        field: 'receivedDt',
        dir: 'desc'
      }];
    }
    this.gridView = orderBy(this.messagesData, this.sort);
    this.gridData = {
      data: this.gridView.slice(this.skip, this.skip + this.pageSize),
      total: this.gridView.length
    };
  }

  viewMessage(dataItem: any) {
    this.msgData = dataItem;
    this.openMessage = true;
  }

  pageChange(event: PageChangeEvent): void {
    this.skip = event.skip;
    this.gridView = this.messagesData;
    this.gridData = {
      data: this.gridView.slice(this.skip, this.skip + this.pageSize),
      total: this.gridView.length
    };
  }

  sortChange(sort: SortDescriptor[]): void {
    this.sort = sort;
    this.gridView = orderBy(this.messagesData, this.sort);
    this.gridData = {
      data: this.gridView.slice(this.skip, this.skip + this.pageSize),
      total: this.gridView.length
    };
  }

  searchGrid(e: any) {
    const optionswithtime = { year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit' } as const;
    this.messagesData.forEach((data: any) => {
      data.id = data.id.toString();
      if (data.receivedDt !== null) {
        data.receivedDt = new Date(data.receivedDt).toLocaleString('en-US', optionswithtime);
      }
      if (data.sendDt !== null) {
        data.sendDt = new Date(data.sendDt).toLocaleString('en-US', optionswithtime);
      }
    });
    this.filters = {
      filters: [
        { field: 'id', value: e.target.value, operator: 'contains', ignoreCase: true },
        { field: 'subject', value: e.target.value, operator: 'contains', ignoreCase: true },
        { field: 'topic', value: e.target.value, operator: 'contains', ignoreCase: true },
        { field: 'receivedDt', value: e.target.value, operator: 'contains' },
        { field: 'sendDt', value: e.target.value, operator: 'contains' }
      ], logic: 'or'
    };
    this.gridView = filterBy(this.messagesData, this.filters);
    this.skip = 0;
    this.gridData = {
      data: this.gridView.slice(this.skip, this.skip + this.pageSize),
      total: this.gridView.length
    };
  }

  /**
   * @description
   * Function to navigate to respective component depending on role
   */
  changeMenu(value: any) {
    this.hiddenColumns = [];
    this.sentMessage = value === 'Sent Messages';
    this.sentMessage ? this.hiddenColumns.push('receivedDt') : this.hiddenColumns.push('sendDt');
    this.filterGridView(value);
  }

  clickedPage(event: any) {
    this.deleteDisabled = true;
    if (event.selectedRows.length > 0) {
      this.selectedData.push(event.selectedRows[0].dataItem.id);
    } else if (event.deselectedRows.length > 0) {
      const index = this.selectedData.indexOf(event.deselectedRows[0].dataItem.id);
      this.selectedData.splice(index, 1);
    }
    if (this.selectedData.length > 0) { this.deleteDisabled = false; }
  }

  /**
   * @description
   * Function to set padding for messages number
   */
  setPaddingClass() {
    let paddingClass = '';
    if (this.messageCount < 11) {
      paddingClass = 'num-padding-single';
    } else {
      paddingClass = 'num-padding-double';
    }
    return paddingClass;
  }
}
